import React from 'react';
import {
    HashRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";

import CacheRoute, { CacheSwitch } from 'react-router-cache-route'

import MainPage from './pages/main/Main';
import { MuiThemeProvider } from '@material-ui/core';
import theme from './services/theming';
import DeviceEventEmitter, { EventName } from './control/event';
import AnimatedRouter from 'react-animated-router';
import 'react-animated-router/animate.css';

import LoginPage from './pages/auth/Login';
import RegisterPage from './pages/auth/Register';
import ForgetPwdPage from './pages/auth/Forgetpwd';
import LoadingPage from './pages/main/Loading';

import SysSettingDialog from './pages/setting/SysSetting';
import MyMsgDialog from './pages/setting/MyMsg';
import SafetyDialog from './pages/setting/safety';
import SelfInfoDialog from './pages/setting/Selfinfo';
import RealNameDialog from './pages/setting/realname';
import AnchorDialog from './pages/setting/Anchor';
import SysMessage from './pages/setting/SysMessage';
import SetPwd from './pages/setting/SetPwd';
import ChangePwd from './pages/setting/changePwd';
import SetPwdCfm from './pages/setting/SetPwdCfm';
import FindPwd from './pages/setting/FindPwd';
import FindPwdCfm from './pages/setting/FindPwdCfm';
import CircleDel from './pages/home/CircleDel';
import CommentDel from './pages/home/commentDel';
import PlayRoom from './pages/room/PlayRoom';


import SettingDialog from './pages/setting/Setting';
import SelfSecret from './pages/setting/selfsecret';

import WalletDialog from './pages/mine/wallet';
import ShopDialog from './pages/mine/Shop';
import HistoryDialog from './pages/mine/History';
import Feedback from './pages/mine/Feedback';
import AboatDlg from './pages/mine/Aboat';

import SearchDialog from './pages/home/Search';
import MoreRecomm from './pages/home/MoreRecomm';
import CustomChannel from './pages/home/CustomChannel'
import NewsDetail from './pages/home/NewsDetail'
import NewsMore from './pages/home/NewsMore'



import Movieplayer from './pages/player/MoviePlayer';
import PrivateLetter from './pages/player/PrivateLetter';
import RedBag from './pages/chat/redBag';
import VipLevel from './pages/mine/VipLevels';
import Accusation from './pages/player/Accusation'

import AnchorRank from './pages/anchor/AnchorRank';

import MatchLeague from './pages/match/MatchLeague'
import MatchChoose from './pages/match/MatchChoose';
import MatchDetail from './pages/match/MatchDetail';
import MatchPlayerDetail from './pages/match/MatchPlayerDetail';
import MatchTeamDetail from './pages/match/MatchTeamDetail';
import MatchArea from './pages/match/MatchArea';
import MatchCountry from './pages/match/MatchCountry';
import MatchCalendar from './pages/match/MatchCalendar';

import SubscribePage from './pages/subscribe/SubscribePage';

import ChatSearchFriend from './pages/chat/ChatSearchFriend';
import ChatAddFriend from './pages/chat/ChatAddFriend';
import ChatBook from './pages/chat/ChatBook';
import ChatGroup from './pages/chat/ChatGroup';

import SubscribeChannel from './pages/subscribe/SubscribeChannel'
import AppUtils from './control/apputlis';
import LoginPhone from './pages/auth/LoginPhone';
import Mine from './pages/mine/Mine';
import Home from './pages/home/Home';
import IntegralWallet from './pages/wallet/IntegralWallet';
import IntegralRule from './pages/wallet/IntegralRule';
import IntegralExchange from './pages/wallet/IntegralExchange';
import IntegralDetail from './pages/wallet/IntegralDetail';
import IntegralGoods from './pages/wallet/IntegralGoods';
import IntegralAddress from './pages/wallet/IntegralAddress';
import MatchPage from './pages/match/MatchPage';
import ChatPage from './pages/chat/ChatPage';
import MRedux from './pages/view/MRedux';



export default class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadCompleted: false,
        };

        this._onLoadComplete = this._onLoadComplete.bind(this);
        AppUtils.YMPush('APP', '启动');
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.LOAD_COMPLETE, this._onLoadComplete, this);
        AppUtils.setStorageItem(AppUtils.MATCH_SELECT_TIMER, 0);
        MRedux.clearAllState();
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.LOAD_COMPLETE, this._onLoadComplete, this);
    }

    _onLoadComplete(e) {
        this.setState({
            loadCompleted: true
        });
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <Router>
                    <CacheSwitch>
                        <Route path="/loading/" component={LoadingPage}></Route>
                        <CacheRoute exact path="/">
                            <MainPage />
                        </CacheRoute>
                        <Route path="/circleDel/:id/:os/:token/:customerId" >
                            <CircleDel />
                        </Route>

                        <Route path="/newsdetail/:id/:os"  >
                            <NewsDetail />
                        </Route>

                        <AnimatedRouter timeout={300} >

                            <Route path="/login">
                                <LoginPage />
                            </Route>
                            <Route path="/chat/:hidden">

                                <ChatPage />
                            </Route>
                            <Route path="/register" >
                                <RegisterPage />
                            </Route>
                            <Route path="/forgetpwd" >
                                <ForgetPwdPage />
                            </Route>
                            <Route path="/search" >
                                <SearchDialog />
                            </Route>
                            <Route path="/history/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId" >
                                <HistoryDialog />
                            </Route>
                            <Route path="/wallet" >
                                <WalletDialog />
                            </Route>
                            <Route path="/shopdialog" >
                                <ShopDialog />
                            </Route>
                            <Route path="/safety" >
                                <SafetyDialog />
                            </Route>
                            <Route path="/setting" >
                                <SettingDialog />
                            </Route>

                            <Route path="/syssetting" >
                                <SysSettingDialog />
                            </Route>
                            <Route path="/mymsg" >
                                <MyMsgDialog />
                            </Route>
                            <Route path="/selfinfo" >
                                <SelfInfoDialog />
                            </Route>
                            <Route path="/anchor" >
                                <AnchorDialog />
                            </Route>
                            <Route path="/realname/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId" >
                                <RealNameDialog />
                            </Route>
                            <Route path="/feedback" >
                                <Feedback />
                            </Route>
                            <Route path="/selfsecret" >
                                <SelfSecret />
                            </Route>

                            <Route path="/play/:room_id/:matchType/:matchId/:uid/:fastkey/:roomIp/:roomPort/:os/:token/:customerId/:fid" >
                                {<Movieplayer />}
                            </Route>

                            {/* <Route path="/movieplay" >
                                {<Movieplayer />}
                            </Route> */}
                            <Route path="/aboat" >
                                <AboatDlg />
                            </Route>
                            <Route path="/setpwd" >
                                <SetPwd />
                            </Route>
                            <Route path="/ChangePwd" >
                                <ChangePwd />
                            </Route>
                            <Route path="/setpwdcfg" >
                                <SetPwdCfm />
                            </Route>
                            <Route path="/findpwd" >
                                <FindPwd />
                            </Route>
                            <Route path="/findpwdcfg" >
                                <FindPwdCfm />
                            </Route>
                            <Route path="/matchleague" >
                                <MatchLeague />
                            </Route>
                            <Route path="/matchchoose/:type_id/" >
                                <MatchChoose />
                            </Route>

                            <Route path="/commentDel" >
                                <CommentDel />
                            </Route>
                            {/* <Route path="/matchchoose" >
                                <MatchChoose />
                            </Route> */}
                            <Route path="/morerecomm/:os" >
                                <MoreRecomm />
                            </Route>
                            <Route path="/customchannel/:os" >
                                <CustomChannel />
                            </Route>
                            <Route path="/anchorrank" >
                                <AnchorRank />
                            </Route>
                            <Route path="/matchdetail" >
                                <MatchDetail />
                            </Route>
                            <Route path="/matcharea/:typeId" >
                                <MatchArea />
                            </Route>
                            <Route path="/matchcountry/:typeId/:Id/:countryId" >
                                <MatchCountry />
                            </Route>
                            <Route path="/matchcalendar/:typeId" >
                                <MatchCalendar />
                            </Route>
                            <Route path="/teamdetail" >
                                <MatchTeamDetail />
                            </Route>
                            <Route path="/playerdetail" >
                                <MatchPlayerDetail />
                            </Route>
                            <Route path="/subscribechannel" >
                                <SubscribeChannel />
                            </Route>
                            <Route path="/privateletter/:user_id/:type" >
                                <PrivateLetter />
                            </Route>
                            <Route path="/redBag/:id" >
                                <RedBag />
                            </Route>
                            <Route path="/sysmessage" >
                                <SysMessage />
                            </Route>
                            <Route path="/accusation/:room_id" >
                                <Accusation />
                            </Route>
                            <Route path="/subscribe/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId" >
                                <SubscribePage />
                            </Route>

                            <Route path="/newsmore" >
                                <NewsMore />
                            </Route>
                            <Route path="/chatsearchfriend" >
                                <ChatSearchFriend />
                            </Route>
                            <Route path="/chataddfriend" >
                                <ChatAddFriend />
                            </Route>
                            <Route path="/chatbook" >
                                <ChatBook />
                            </Route>
                            <Route path="/chatgroup" >
                                <ChatGroup />
                            </Route>
                            <Route path="/loginphone" >
                                <LoginPhone />
                            </Route>
                            <Route path="/integralwallet/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId" >
                                <IntegralWallet />
                            </Route>
                            <Route path="/integralwallet/:channel/:uid/:token/:nav" >
                                <IntegralWallet />
                            </Route>
                            <Route path="/integralrule/:nav" >
                                <IntegralRule />
                            </Route>

                            <Route path="/integralexchange/:channel/:uid/:token/:nav/:score/:total" >
                                <IntegralExchange />
                            </Route>

                            <Route path="/integraldetail/:channel/:uid/:token/:nav" >
                                <IntegralDetail />
                            </Route>
                            <Route path="/integralgoods/:channel/:uid/:token/:nav" >
                                <IntegralGoods />
                            </Route>
                            <Route path="/integraladdress/:channel/:uid/:token/:giftid/:num/:nav" >
                                <IntegralAddress />
                            </Route>
                            <Route path="/mine" >
                                <Mine />
                            </Route>

                            {/* <Route path="/home/:channel/:uid/:token/:nav/:phone/:fastkey/:fid/:os" >
                                <Home />
                            </Route> */}
                            <Route path="/home/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId/:fid" >
                                <Home />
                            </Route>
                            <Route path="/match/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId/:fid" >
                                <MatchPage />
                            </Route>
                            <Route path="/viplevel/:os/:token/:uid/:fastkey/:roomIp/:roomPort/:customerId" >
                                <VipLevel />
                            </Route>
                            <Route path="/viplevel/:channel/:uid/:token/:nav" >
                                <VipLevel />
                            </Route>
                            <Route path="/room/:match_type/:match_id">
                                <PlayRoom />
                            </Route>

                        </AnimatedRouter>
                    </CacheSwitch>
                </Router>
            </MuiThemeProvider >
        );
    }
}
